type ExecutarDownloadDeArquivos = {
  conteudo: Blob | string
  nome: string
  extensao: string
  tipo?: string
}

export function usarBaixadorDeArquivos() {
  const executarDownloadPorURL = (dados: Blob) => {
    const link = document.createElement("a")
    const data = window.URL.createObjectURL(dados)
    document.body.appendChild(link)
    link.href = data
    link.click()
    window.URL.revokeObjectURL(data)
    link.remove()
  }
  const executarDownloadDeArquivo = ({
    conteudo,
    nome,
    extensao,
    tipo = "",
  }: ExecutarDownloadDeArquivos): void => {
    const link = document.createElement("a")
    const file = new Blob([conteudo], {
      type: tipo,
    })

    link.href = window.URL.createObjectURL(file)
    link.download = nome + extensao
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(link.href)
    link.remove()
  }
  return {
    executarDownloadPorURL,
    executarDownloadDeArquivo,
  }
}
